import React, { useState, useContext } from 'react';
import TFAConfigContainer from '@nile/components/src/Containers/Login/TFAConfigContainer';
import {
  Icon,
  HeaderTag,
  getTranslatedText,
  toast,
  AppContext,
  getCookieValue,
  getHeaderValue,
  SecurityConfig,
  fetchApi
} from '@nile/components';

import { FormattedMessage, injectIntl } from 'react-intl';
import envConfig from '@nile/home/src/Config/env';
import { withRouter } from 'react-router-dom';
import { Card } from '@superops/ui-design-system';
import styled from 'styled-components';
import { DisplayText } from '@shopify/polaris';

const TFAContainer = (props) => {
  const { intl } = props;

  const app = useContext(AppContext);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [verifyToken, setVerifyToken] = useState('');
  const handleEnableTFA = async (value) => {
    setButtonLoader(true);
    const formData = new FormData();
    formData.append('passcode', value);
    formData.append('authenticationVerifiedToken', verifyToken);

    const requestOptions = {
      method: 'POST',
      body: formData,
      credentials: 'include',
      headers: getHeaderValue()
    };
    try {
      const response = await fetchApi(
        `${envConfig.loginRoot}/user/verifyandenabletfa`,
        requestOptions
      );
      const data = await response.json();
      if (data) {
        toast(
          'success',
          'Two Factor Authentication has been configured successfully'
        );
        // await app.getUser();
        // await app.getCompany();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        props.history.push('/home');
      } else {
        setButtonLoader(false);
        toast('error', `app.errorCode.${response.status}`);
      }
      // TODO: Handle based on true/false
    } catch (err) {
      // toast('error', 'Something went wrong');
      new Error(err);
    }
    setButtonLoader(false);
  };

  const verifyPasswordAndPasscode = async (currentPassword) => {
    const formData = new FormData();
    formData.append('currentPassword', currentPassword);

    const requestOptions = {
      method: 'POST',
      body: formData,
      credentials: 'include',
      headers: getHeaderValue()
    };
    setButtonLoader(true);
    const response = await fetchApi(
      `${envConfig.loginRoot}/user/verifycurrentpasswordandpasscode`,
      requestOptions
    );
    if (response.status === 200) {
      let token = await response.text();
      setVerifyToken(token);
    } else {
      toast('error', `app.errorCode.${response.status}`);
    }

    setButtonLoader(false);
  };

  const handleData = (data) => {
    verifyPasswordAndPasscode(data);
  };

  return (
    <div className="fx actr jcenter fhp">
      {verifyToken ? (
        <Card padding="sizeSmall">
          <div className="flex-row">
            <div className="flex actr flex-item-balloon">
              <div className="flex-item-balloon">
                <HeaderTag
                  title={getTranslatedText(
                    intl,
                    'admin.myprofile.security.twoFactor'
                  )}
                  isBgStrip
                />
              </div>
            </div>
            <div className="flex-item-fixed"></div>
          </div>

          <div className="mb20">
            <DisplayText size="medium">
              <FormattedMessage id="admin.myprofile.security.TwoFactor.desc" />
            </DisplayText>
          </div>
          <TFAConfigContainer
            loader={buttonLoader}
            handleEnableTFA={handleEnableTFA}
            authenticationVerifiedToken={verifyToken}
          />
        </Card>
      ) : (
        <SecurityConfig
          isPublic
          handleData={handleData}
          proceedTill={'currentPassword'}
          buttonLoader={buttonLoader}
        />
      )}
    </div>
  );
};

export default injectIntl(withRouter(TFAContainer));
